var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"color":"error","outlined":""},on:{"click":function($event){return _vm.removeModel(_vm.modelId)}}},[_vm._v(_vm._s(_vm.$t('remove-model.btn')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }